module.exports = __webpack_public_path__ + "img/20180815_151844_208.66fb7baf.jpg";